import { render } from "./NowPlaying.vue?vue&type=template&id=df617082&scoped=true"
import script from "./NowPlaying.vue?vue&type=script&lang=js"
export * from "./NowPlaying.vue?vue&type=script&lang=js"

import "./NowPlaying.vue?vue&type=style&index=0&id=df617082&scoped=true&lang=css"

import exportComponent from "/vercel/path0/new-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df617082"]])

export default __exports__